

// import React, { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import axios from "axios";
// import { fetchOrganizationDetails } from "../../Store/IAM/iamSlice";
// import remarkIcon from "./Frame 433.png";
// import searchIcon from "./search.png";
// import moment from "moment";
// import "./iamSidebar.css";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import refreshIcon from "./refresh.png";


// const InspectSuper = () => {
//   const dispatch = useDispatch();
//   const [searchTerm, setSearchTerm] = useState("");
//   const [auditData, setAuditData] = useState([]);
//   const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));
//   const [startDate, setStartDate] = useState(moment().startOf('month').format("YYYY-MM-DD"));
//   const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
//   const [userName,setUserName] = useState([])
//   const [selectedOrg, setSelectedOrg] = useState(""); // State for selected organization
//   const [selectedProgram, setSelectedProgram] = useState(""); // State for selected organization
//   const [selectedCaseId, setSelectedCaseId] = useState(""); // State for selected case ID
//   const [isDataFetched, setIsDataFetched] = useState(false);
//   const [agents, setAgents] = useState({});
//   const [caseIds, setCaseIds] = useState([]); // State for case IDs
//   const [orgNames, setOrgNames] = useState([]); // State for case IDs
//   const [progNames, setProgNames] = useState([]); // State for case IDs
//   const user = localStorage.getItem("insuranceUser");
//   const user_info = JSON.parse(user);
//   const exportToExcel = () => {
//     // Filter only processed rows
//     const processedData = filteredData.filter(row => row.status.toLowerCase() === "processed");

//     const exportData = processedData.map(row => ({
//       Date: row.date,
//       "Case ID": row.caseId,
//       Status: row.status,
//       Report: pdfLinks[row.audit] ? pdfLinks[row.audit] : "Not generated",
//       "Organisation Name": row.orgName,
//       Remark: row.remark || "N/A",
//     }));

//     const worksheet = XLSX.utils.json_to_sheet(exportData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Audit Report");

//     const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//     const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
//     saveAs(dataBlob, `Processed_Audit_Report_${moment().format("YYYY-MM-DD_HH-mm")}.xlsx`);
//   };

//   const fetchAuditData = async () => {
//     setIsRefreshing(true);
//     try {
//       const response = await axios.get("/auth/allOrgData", {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       const apiResponse = response.data;

//       // Step 1: Flatten backend data
//       let orgData = apiResponse.flatMap(org =>
//         org.orgData.map(data => ({
//           ...data,
//           orgName: org.orgName, // default
//           programName: org.programName
//         }))
//       );

//       // Step 2: Collect all audit IDs
//       const auditIds = orgData.map(row => row.audit).filter(Boolean);

//       // Step 3: Fetch S3 details in batch
//       const batchResponse = await axios.post('/auth/batch_check_and_get_details', { auditIds });
//       const batchData = batchResponse.data.audits;
//       console.log("232", batchData);

//       // Step 4: Map insuranceCompany from batch results
//       const batchMap = batchData.reduce((acc, item) => {
//         acc[item.id] = item.details['Insurance Company'] || ''; 
//         return acc;
//       }, {});

//       orgData = orgData.map(row => ({
//         ...row,
//         orgName: batchMap[row.audit] || row.orgName || ''
//       }));

//       // Step 5: Filter by date
//       const filteredByDate = orgData.filter(row => {
//         if (!row.date) return false;
//         const rowDate = moment(row.date).startOf("day");
//         return rowDate.isSameOrAfter(moment(startDate).startOf("day")) &&
//           rowDate.isSameOrBefore(moment(endDate).startOf("day"));
//       });

//       // Step 6: Unique IDs / Names
//       setCaseIds([...new Set(filteredByDate.map(row => row.audit))]);
//       setOrgNames([...new Set(filteredByDate.map(row => row.orgName))]);
//       setProgNames([...new Set(filteredByDate.map(row => row.programName))]);
//       setUserName([...new Set(filteredByDate.map(row => row.userName))]);

//       // Step 7: Format table data
//       const formattedData = filteredByDate.map(row => ({
//         date: moment(row.date).format("YYYY-MM-DD HH:mm:ss"),
//         caseId: row.audit,
//         name: row.name || "xyz",
//         status: row.used,
//         audit: row.audit,
//         orgName: row.orgName || "Unknown Insurance Company",
//         remark: row.remark,
//         userID: row.userID,
//         programName: row.programName,
//       }));

//       formattedData.sort((a, b) => moment(b.date).valueOf() - moment(a.date).valueOf());

//       setOriginalAuditData(formattedData);
//       setAuditData(formattedData);
//       setIsDataFetched(true);

//     } catch (error) {
//       console.error("Error fetching audit data:", error);
//       setAuditData([]);
//       setIsDataFetched(true);
//     } finally {
//       setIsRefreshing(false);
//       setShowToast(true);
//       setTimeout(() => setShowToast(false), 2000);
//     }
//   };



//   const toggleOrgSort = () => {
//     let sortedData;

//     if (orgSortOrder === "default" || orgSortOrder === "desc") {
//       sortedData = [...auditData].sort((a, b) =>
//         a.orgName.localeCompare(b.orgName)
//       );
//       setOrgSortOrder("asc");
//     } else if (orgSortOrder === "asc") {
//       sortedData = [...auditData].sort((a, b) =>
//         b.orgName.localeCompare(a.orgName)
//       );
//       setOrgSortOrder("desc");
//     }

//     setAuditData(sortedData);
//   };
//   useEffect(() => {
//     fetchAuditData();
//   }, [startDate, endDate]); // Trigger fetch when either date changes


//   const toggleDateSort = () => {
//     let sortedData;

//     if (dateSortOrder === "default" || dateSortOrder === "asc") {
//       sortedData = [...auditData].sort(
//         (a, b) => new Date(b.date) - new Date(a.date) // Latest first
//       );
//       setDateSortOrder("desc");
//     } else {
//       sortedData = [...auditData].sort(
//         (a, b) => new Date(a.date) - new Date(b.date) // Oldest first
//       );
//       setDateSortOrder("asc");
//     }

//     setAuditData(sortedData);
//   };
//   useEffect(() => {
//     fetchAuditData();
//   }, [selectedDate]); // Runs every time selectedDate changes

//   // Filter data based on selected filters
//   const filteredData = auditData.filter((row) =>
//     // Case ID filter
//     (row.caseId.toLowerCase().includes(selectedCaseId.toLowerCase()) || !selectedCaseId) &&

//     // Org filter
//     (row.orgName.toLowerCase().includes(selectedOrg.toLowerCase()) || !selectedOrg) &&

//     // Program filter
//     (row.programName?.toLowerCase().includes(selectedProgram.toLowerCase()) || !selectedProgram) &&

//     // Search filter (caseId or status)
//     (
//       row.caseId.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       row.status.toLowerCase().includes(searchTerm.toLowerCase())
//     )
//   );


//   const link_to_pdf = async (audit_id) => {
//     // ✅ S3 object key format (must match backend convention)
//     const objectKey = `Insurance_Inspection/downloadedPdf/${audit_id}.pdf`;

//     try {
//       const response = await fetch("/auth/check_document_exists", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ objectKey }), // ✅ send S3 key
//       });

//       const data = await response.json();
//       console.log("S3 PDF response:", audit_id, data);

//       if (data.exists && data.url) {
//         return data.url; // signed S3 URL if found
//       } else {
//         return null; // file not found
//       }
//     } catch (error) {
//       console.error("Error fetching signed S3 URL:", error);
//       return null;
//     }
//   };


//   const [pdfLinks, setPdfLinks] = useState({});

//   useEffect(() => {
//     const checkAllLinks = async () => {
//       const links = {};
//       for (const row of auditData) {
//         const url = await link_to_pdf(row.audit); // 🔍 check S3 here
//         if (url) {
//           links[row.audit] = url;
//         }
//       }
//       setPdfLinks(links);
//     };

//     if (auditData.length > 0) {
//       checkAllLinks();
//     }
//   }, [auditData]);

//   const getStatusClass = (status) => {
//     switch (status.toLowerCase()) {
//       case "processing":
//         return { backgroundColor: "rgba(247, 165, 29, 1)", color: "white" };
//       case "processed":
//       case "completed":
//         return { backgroundColor: "rgba(31, 68, 136, 1)", color: "white" };
//       case "accessed":
//         return { backgroundColor: "#ff0083", color: "white" };
//       default:
//         return { backgroundColor: "grey", color: "white" };
//     }
//   };
//   const [showRemarkPopup, setShowRemarkPopup] = useState(false);
//   const [selectedRemark, setSelectedRemark] = useState("");
//   const token = user_info.token; const [isRefreshing, setIsRefreshing] = useState(false);
//   const [showToast, setShowToast] = useState(false);
//   const [orgSortOrder, setOrgSortOrder] = useState("default"); // none | asc | desc
//   const [originalAuditData, setOriginalAuditData] = useState([]); // to restore
//   const [dateSortOrder, setDateSortOrder] = useState("default");




//   return (
//     <div className="inspect-container">
//       <div className="card">
//         <div className="card-header">
//           <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//             <h2 style={{ margin: 0 }}>Inspect</h2>
//             <div style={{ margin: 0 }}>Additional text</div>
//             {/* <img
//               src="https://w7.pngwing.com/pngs/1015/1010/png-transparent-user-interface-download-cloud-down-arrow-ui-user-interface-icon.png"
//               alt="Download"
//               title="Download as Excel"
//               onClick={exportToExcel} // You’ll add Excel download here
//               style={{
//                 width: "15px",
//                 height: "15px",
//                 cursor: "pointer",
//                 // filter: "brightness(0) saturate(100%) invert(31%) sepia(17%) saturate(2390%) hue-rotate(182deg) brightness(97%) contrast(89%)"
//               }}
//             /> */}
//           </div>
//           <div className="search-refresh-wrapper" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//             <div className="search-bar" style={{ flex: 1 }}>
//               <input
//                 type="text"
//                 placeholder="Search ..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 style={{ width: "100%" }}
//               />
//               <img src={searchIcon} alt="Search" className="search-icon" />
//             </div>

//             {/* Total audits count badge in the middle */}
//             {/* <div
//               style={{
//                 backgroundColor: "#1f4488",
//                 color: "white",
//                 padding: "2px 12px",
//                 borderRadius: "12px",
//                 fontSize: "12px",
//                 fontWeight: "bold",
//                 minWidth: "40px",
//                 textAlign: "center",
//               }}
//               title="Total audits for current date range"
//             >
//               {filteredData.length}
//             </div> */}

//             {/* <div
//               className={`refresh-icon-wrapper ${isRefreshing ? "spinning" : ""}`}
//               onClick={fetchAuditData}
//               title="Refresh"
//               style={{ display: "flex", alignItems: "center" }}
//             >
//               <img src={refreshIcon} alt="refresh" className="refresh-icon" />
//             </div> */}
//           </div>


//         </div>
//         {showToast && (
//           <div className="toast-popup">
//             Table Refreshed
//           </div>
//         )}



//         <div className="filters">
//           {/* <input
//             type="date"
//             value={startDate}
//             onChange={(e) => setStartDate(e.target.value)}
//           />
//           <input
//             type="date"
//             value={endDate}
//             onChange={(e) => setEndDate(e.target.value)}
//           /> */}
// <DateRangePicker
//   startDate={startDate}
//   endDate={endDate}
//   onStartDateChange={setStartDate}
//   onEndDateChange={setEndDate}
// />
//           {/* Insurance Company filter */}
//           <select onChange={(e) => setSelectedOrg(e.target.value)}>
//             <option value="">Organization</option>
//             {orgNames.map((orgName) => (
//               <option key={orgName} value={orgName}>
//                 {orgName}
//               </option>
//             ))}
//           </select>

//           {/* Program filter */}
//           {/* <select onChange={(e) => setSelectedProgram(e.target.value)}>
//             <option value="">All Program</option>
//             {progNames.map((progName) => (
//               <option key={progName} value={progName}>
//                 {progName}
//               </option>
//             ))}
//           </select> */}

//           {/* Case ID filter */}
//           <select onChange={(e) => setSelectedCaseId(e.target.value)}>
//             <option value="">All Case ID</option>
//             {caseIds.map((caseId) => (
//               <option key={caseId} value={caseId}>
//                 {caseId}
//               </option>
//             ))}
//           </select>
//              <select onChange={(e) => setUserName(e.target.value)}>
//             <option value="">Username</option>
//             {userName.map((caseId) => (
//               <option key={caseId} value={caseId}>
//                 {caseId}
//               </option>
//             ))}
//           </select>
//         </div>

//         <div className="table-wrapper">
//           <table>
//             <thead>
//               <tr>
//                 <th>
//                  Start Date
//                   {/* <span
//                     className="sort-icon"
//                     onClick={toggleDateSort}
//                     title="Sort by Date"
//                     style={{ marginLeft: "5px", cursor: "pointer" }}
//                   >
//                     ⬍
//                   </span> */}
//                 </th>
// <th>End Date</th>
//                 <th>Case ID</th>
//                 <th>Name</th>
//                 <th>inspection</th>
//                 <th>Status</th>
//                 <th>Report</th>
//                 {/* <th>Program Name</th>  */}
//                 {/* <th>
//                   Insurance Company
//                   <span
//                     className="sort-icon"
//                     onClick={toggleOrgSort}
//                     title="Sort by Org Name"
//                     style={{ marginLeft: "5px", cursor: "pointer" }}
//                   >
//                     ⬍
//                   </span>
//                 </th> */}

// <th>Vet Name</th>
//                 <th>Remark</th>
//               </tr>
//             </thead>
//             <tbody>
//               {!isDataFetched ? (
//                 <tr>
//                   <td colSpan="6" className="no-results">
//                     No data available
//                   </td>
//                 </tr>
//               ) : filteredData.length > 0 ? (
//                 filteredData.map((row, index) => (
//                   <tr key={index}>
//                     <td>{row.date}</td>
//                     <td>{row.caseId}</td>
//                     <td>
//                       <span className="status" style={getStatusClass(row.status)}>
//                         {row.status}
//                       </span>
//                     </td>

//                     <td>
//                       {row.status === "processed" && pdfLinks[row.audit] ? (
//                         <a
//                           href={pdfLinks[row.audit]}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           style={{
//                             color: "#ff0083",
//                             textDecoration: "none",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             whiteSpace: "nowrap",
//                             display: "inline-block",
//                             maxWidth: "150px",
//                             verticalAlign: "middle",
//                             padding: "2px",
//                           }}
//                           title={pdfLinks[row.audit]}
//                         >
//                           View
//                         </a>
//                       ) : (
//                         "Not generated"
//                       )}
//                     </td>
//                     <td>{row.programName || "-"}</td>


//                     <td>{row.orgName}</td>

//                     <td>
//                       {row.remark && row.status === "processed" ? (
//                         <div
//                           className="tooltip-container clickable"
//                           title={row.remark}
//                           onClick={() => {
//                             setSelectedRemark(row.remark);
//                             setShowRemarkPopup(true);
//                           }}
//                         >
//                           <img
//                             src={remarkIcon}
//                             alt="Remark"
//                             className="remark-icon"
//                             style={{
//                               filter:
//                                 "brightness(90) saturate(0%) invert(21%) sepia(92%) saturate(7030%) hue-rotate(308deg) brightness(100%) contrast(124%)",
//                             }}
//                           />
//                         </div>
//                       ) : (
//                         <div className="tooltip-container">
//                           <img
//                             src={remarkIcon}
//                             alt="No Remark"
//                             className="remark-icon"
//                             style={{
//                               filter: "grayscale(100%) brightness(80%)",
//                             }}
//                           />
//                         </div>
//                       )}
//                     </td>



//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="6" className="no-results">
//                     No results found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//       {showRemarkPopup && (
//         <div className="remark-popup-overlay" onClick={() => setShowRemarkPopup(false)}>
//           <div className="remark-popup" onClick={(e) => e.stopPropagation()}>
//             <h3>Remark</h3>
//             <p>{selectedRemark}</p>
//             <button onClick={() => setShowRemarkPopup(false)}>Close</button>
//           </div>
//         </div>
//       )}

//     </div>
//   );
// };

// export default InspectSuper;



import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";
import { fetchOrganizationDetails } from "../../Store/IAM/iamSlice";
import remarkIcon from "./Frame 433.png";
import searchIcon from "./search.png";
import moment from "moment";
import "./iamSidebar.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import refreshIcon from "./refresh.png";
import { DateRangePicker } from "react-date-range"; // or your picker library
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import arrowImg from "./InspectSuper.png";
import calender from './calendar_today.png';
import pngdownload from "./pngdownload.jpg"; // your icon
const InspectSuper = () => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [auditData, setAuditData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));
  // const [startDate, setStartDate] = useState(moment().startOf('month').format("YYYY-MM-DD"));
  // const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [userName, setUserName] = useState([]);
  const [startDate, setStartDate] = useState(
      moment().subtract(30, "days").toDate()
        );
    const [endDate, setEndDate] = useState(
      moment().endOf("day").toDate()
    );
  const [selectedOrg, setSelectedOrg] = useState("");
  const [selectedProgram, setSelectedProgram] = useState("");
  const [selectedCaseId, setSelectedCaseId] = useState("");
  // const [isDataFetched, setIsDataFetched] = useState(false);
  const [agents, setAgents] = useState({});
  const [caseIds, setCaseIds] = useState([]);
  const [orgNames, setOrgNames] = useState([]);
  const [progNames, setProgNames] = useState([]);
  const user = localStorage.getItem("insuranceUser");
  const user_info = JSON.parse(user);
  const token = user_info.token;
  const [tempStartDate, setTempStartDate] = useState(startDate);
  const [tempEndDate, setTempEndDate] = useState(endDate);

  const [isRefreshing, setIsRefreshing] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [orgSortOrder, setOrgSortOrder] = useState("default");
  const [originalAuditData, setOriginalAuditData] = useState([]);
  const [dateSortOrder, setDateSortOrder] = useState("default");
  const [showRemarkPopup, setShowRemarkPopup] = useState(false);
  const [selectedRemark, setSelectedRemark] = useState("");
  const [pdfLinks, setPdfLinks] = useState({});
  // const [startDate, setStartDate] = useState(new Date());
  // const [endDate, setEndDate] = useState(new Date());
  const [isDateModalOpen, setIsDateModalOpen] = useState(false);
const [selectedUserName, setSelectedUserName] = useState(""); // string for selected filter

  // const exportToExcel = () => {
  //   const processedData = filteredData.filter(row => row.status.toLowerCase() === "processed");
  //   const exportData = processedData.map(row => ({
  //     Date: row.date,
  //     "Case ID": row.caseId,
  //     Status: row.status,
  //     Report: pdfLinks[row.audit] ? pdfLinks[row.audit] : "Not generated",
  //     "Organisation Name": row.orgName,
  //     Remark: row.remark || "N/A",
  //   }));

  //   const worksheet = XLSX.utils.json_to_sheet(exportData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Audit Report");
  //   const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  //   const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
  //   saveAs(dataBlob, `Processed_Audit_Report_${moment().format("YYYY-MM-DD_HH-mm")}.xlsx`);
  // };
const handleApplyDateRange = () => {
  setStartDate(tempStartDate);
  setEndDate(moment(tempEndDate).endOf("day").toDate());
  setIsDateModalOpen(false);
};
const exportToExcel = () => {
  if (!auditData || auditData.length === 0) {
    alert("No data to export");
    return;
  }

  // Only export filtered data
  const exportData = filteredData.map(row => ({
    Date: row.date,
    "Case ID": row.caseId,
    Name: row.name,
    Status: row.status || "N/A",
    "Insurance Company": row.orgName,
    Remark: row.remark || "N/A",
  }));

  // Create worksheet
  const worksheet = XLSX.utils.json_to_sheet(exportData);

  // Create workbook and append worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Audit_Report");

  // Convert to buffer
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

  // Save as file
  const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(
    dataBlob,
    `Audit_Report_${moment().format("YYYY-MM-DD_HH-mm")}.xlsx`
  );
};


  // const fetchAuditData = async () => {
  //   setIsRefreshing(true);
  //   try {
  //     const response = await axios.get("/auth/allOrgData", {
  //       headers: { Authorization: `Bearer ${token}` },
  //     });
  //     const apiResponse = response.data;

  //     let orgData = apiResponse.flatMap(org =>
  //       org.orgData.map(data => ({
  //         ...data,
  //         orgName: org.orgName,
  //         programName: org.programName
  //       }))
  //     );

  //     const auditIds = orgData.map(row => row.audit).filter(Boolean);
  //     const batchResponse = await axios.post('/auth/batch_check_and_get_details', { auditIds });
  //     const batchData = batchResponse.data.audits;

  //     const batchMap = batchData.reduce((acc, item) => {
  //       acc[item.id] = item.details['Insurance Company'] || '';
  //       return acc;
  //     }, {});

  //     orgData = orgData.map(row => ({
  //       ...row,
  //       orgName: batchMap[row.audit] || row.orgName || ''
  //     }));

  //     const filteredByDate = orgData.filter(row => {
  //       if (!row.date) return false;
  //       const rowDate = moment(row.date).startOf("day");
  //       return rowDate.isSameOrAfter(moment(startDate).startOf("day")) &&
  //         rowDate.isSameOrBefore(moment(endDate).startOf("day"));
  //     });

  //     setCaseIds([...new Set(filteredByDate.map(row => row.audit))]);
  //     setOrgNames([...new Set(filteredByDate.map(row => row.orgName))]);
  //     setProgNames([...new Set(filteredByDate.map(row => row.programName))]);
  //     setUserName([...new Set(filteredByDate.map(row => row.userName))]);

  //     const formattedData = filteredByDate.map(row => ({
  //       date: moment(row.date).format("YYYY-MM-DD HH:mm:ss"),
  //       caseId: row.audit,
  //       name: row.name || "xyz",
  //       status: row.used,
  //       audit: row.audit,
  //       orgName: row.orgName || "Unknown Insurance Company",
  //       remark: row.remark,
  //       userID: row.userID,
  //       programName: row.programName,
  //       userName: row.userName,
  //     }));

  //     formattedData.sort((a, b) => moment(b.date).valueOf() - moment(a.date).valueOf());

  //     setOriginalAuditData(formattedData);
  //     setAuditData(formattedData);
  //     setIsDataFetched(true);

  //   } catch (error) {
  //     console.error("Error fetching audit data:", error);
  //     setAuditData([]);
  //     setIsDataFetched(true);
  //   } finally {
  //     setIsRefreshing(false);
  //     setShowToast(true);
  //     setTimeout(() => setShowToast(false), 2000);
  //   }
  // };
const fetchAuditData = async () => {
  try {
    setLoading(true);

    const response = await axios.get("/auth/allOrgData", {
      params: {
        startDate: moment(startDate).format("YYYY-MM-DD"),
        endDate: moment(endDate).format("YYYY-MM-DD"),
      },
    });

    // const orgData = response.data || [];

    // const formattedData = orgData.map(row => ({
    //   date: row.date,
    //   caseId: row.audit,
    //   name: row.name || "xyz",
    //   status: row.used,
    //   audit: row.audit,
    //   orgName: row.orgName || "Unknown Insurance Company",
    //   remark: row.remark,
    //   userID: row.userID,
    //   programName: row.programName,
    //   userName: row.userName,
    // }));

    // formattedData.sort(
    //   (a, b) => moment(b.date).valueOf() - moment(a.date).valueOf()
    // );

    // setAuditData(formattedData);
    const orgData = response.data || [];

const formattedData = orgData.flatMap(org =>
  (org.orgData || []).map(row => ({
    date: row.date,
    caseId: row.audit,
    name: row.agentName?.trim() || "arun",
    status: row.used,
    audit: row.audit,
    orgName: org.orgName || "Unknown Insurance Company",
    remark: row.remark,
    userID: row.userID,
    programName: org.programName,
    userName: row.userName || "",
  }))
);
console.log("Formatted Table Data:", formattedData);
const uniqueOrgNames = [
  ...new Set(formattedData.map(item => item.orgName).filter(Boolean))
];

setOrgNames(uniqueOrgNames);
const uniqueUserNames = [
  ...new Set(formattedData.map(item => item.name).filter(Boolean))
];

setUserName(uniqueUserNames);
const uniqueCaseIds = [
  ...new Set(formattedData.map(item => item.caseId).filter(Boolean))
];

setCaseIds(uniqueCaseIds);

formattedData.sort(
  (a, b) => moment(b.date).valueOf() - moment(a.date).valueOf()
);

setAuditData(formattedData);
setLoading(false); // ✅ VERY IMPORTANT

  } catch (error) {
    console.error("Error fetching audit data", error);
  } finally {
    setLoading(false);
  }
};

 useEffect(() => {
  if (startDate && endDate) {
    fetchAuditData();
  }
}, [startDate, endDate]);
 
  // useEffect(() => {
  //   fetchAuditData();
  // }, [startDate, endDate]);

  const link_to_pdf = async (audit_id) => {
    const objectKey = `Insurance_Inspection/downloadedPdf/${audit_id}.pdf`;
    try {
      const response = await fetch("/auth/check_document_exists", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ objectKey }),
      });
      const data = await response.json();
      if (data.exists && data.url) {
        return data.url;
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error fetching signed S3 URL:", error);
      return null;
    }
  };

  useEffect(() => {
    const checkAllLinks = async () => {
      const links = {};
      for (const row of auditData) {
        const url = await link_to_pdf(row.audit);
        if (url) {
          links[row.audit] = url;
        }
      }
      setPdfLinks(links);
    };

    if (auditData.length > 0) {
      checkAllLinks();
    }
  }, [auditData]);
const getStatusClass = (status) => {
  // Handle null, undefined, or empty string
  if (!status) {
    return { backgroundColor: "grey", color: "white" };
  }
  
  const statusLower = status.toLowerCase();
  switch (statusLower) {
    case "processing":
      return { backgroundColor: "rgba(247, 165, 29, 1)", color: "white" };
    case "processed":
    case "completed":
      return { backgroundColor: "rgba(31, 68, 136, 1)", color: "white" };
    case "accessed":
      return { backgroundColor: "#ff0083", color: "white" };
    default:
      return { backgroundColor: "grey", color: "white" };
  }
};
console.log(auditData,'auditData');
  // const getStatusClass = (status) => {
  //   switch (status.toLowerCase()) {
  //     case "processing":
  //       return { backgroundColor: "rgba(247, 165, 29, 1)", color: "white" };
  //     case "processed":
  //     case "completed":
  //       return { backgroundColor: "rgba(31, 68, 136, 1)", color: "white" };
  //     case "accessed":
  //       return { backgroundColor: "#ff0083", color: "white" };
  //     default:
  //       return { backgroundColor: "grey", color: "white" };
  //   }
  // };

  // Filter data based on selected filters
  // const filteredData = auditData.filter((row) =>
  //   (row.caseId.toLowerCase().includes(selectedCaseId.toLowerCase()) || !selectedCaseId) &&
  //   (row.orgName.toLowerCase().includes(selectedOrg.toLowerCase()) || !selectedOrg) &&
  //   (row.programName?.toLowerCase().includes(selectedProgram.toLowerCase()) || !selectedProgram) &&
  //   // (row.userName?.toLowerCase().includes(userName.toLowerCase()) || !userName) 
  //   (row.userName?.toLowerCase().includes(selectedUserName.toLowerCase()) || !selectedUserName)

  //   &&
  //   (
  //     row.caseId.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     row.status.toLowerCase().includes(searchTerm.toLowerCase())
  //   )
  // );
  const filteredData = auditData.filter((row) => {
  const search = searchTerm.toLowerCase();

  return (
    ((row.caseId || "").toLowerCase().includes((selectedCaseId || "").toLowerCase()) || !selectedCaseId) &&
    ((row.orgName || "").toLowerCase().includes((selectedOrg || "").toLowerCase()) || !selectedOrg) &&
    ((row.programName || "").toLowerCase().includes((selectedProgram || "").toLowerCase()) || !selectedProgram) &&
    ((row.name || "").toLowerCase().includes((selectedUserName || "").toLowerCase()) || !selectedUserName) &&
    (
      (row.caseId || "").toLowerCase().includes(search) ||
      (row.agentName || "").toLowerCase().includes(search)
    )
  );
});

  return (
    <div className="inspect-container">
      <div className="card">
        {/* <div className="card-header">
          <div style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
            <h2 style={{ margin: 0 }}>Inspect</h2>
            <div style={{
              color: "#9E9E9E",
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 400,
              fontSize: "14px",
              letterSpacing: "0.15px",
              marginTop: "4px",
              borderRadius: "4px",
              width: "fit-content"
            }}>
              Additional text
            </div>
            <div style={{ marginRight: "auto" }}>
              <div style={{
              color: "#9E9E9E",
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 400,
              fontSize: "14px",
              letterSpacing: "0.15px",
              marginTop: "4px",
              borderRadius: "4px",
              width: "fit-content"
            }}>
              Download 
            </div>
          <img
            src={pngdownload}
            alt="Download Excel"
            onClick={exportToExcel}
            style={{ cursor: "pointer", width: "24px", height: "24px" }}
            title="Download Excel"
          />
        </div>
          </div>

         
       <div className="search-refresh-wrapper" style={{ display: "flex", alignItems: "center", gap: "10px" ,  height: "56px", width: "230px"}}>
            <div className="search-bar" style={{ flex: 1,padding:'11px' }}>
              <input
                type="text"
                placeholder="Search ..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ width: "100%" }}
              />
              <img src={searchIcon} alt="Search" className="search-icon" />
            </div>
          </div>
        </div> */}
<div className="card-header">
  <div style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>

    <h2 style={{ margin: 0, textAlign: "center", alignItems: "center" }}>Inspect</h2>

    <div
      style={{
        color: "#9E9E9E",
        fontFamily: "Montserrat, sans-serif",
        fontWeight: 400,
        fontSize: "14px",
        letterSpacing: "0.15px",
        marginTop: "4px",
        borderRadius: "4px",
        width: "fit-content"
      }}
    >
      Additional text
    </div>

    {/* 🔑 KEY CHANGE HERE */}
    <div style={{ 
      display: "flex",
      alignItems: "center",
      gap: "6px",
      marginTop: "4px"
    }}>
      <div
        style={{
          color: "#9E9E9E",
          fontFamily: "Montserrat, sans-serif",
          fontWeight: 400,
          fontSize: "14px",
          letterSpacing: "0.15px",
          borderRadius: "4px",
          width: "fit-content"
        }}
      >
        Download
      </div>

      <img
        src={pngdownload}
        alt="Download Excel"
        onClick={exportToExcel}
        style={{ cursor: "pointer", width: "24px", height: "24px" }}
        title="Download Excel"
      />
    </div>

  </div>
</div>

        {showToast && (
          <div className="toast-popup">
            Table Refreshed
          </div>
        )}
  

        <div className="filters">
          {/* Fixed: Use individual date inputs instead of undefined DateRangePicker */}
         <div style={{  position: "relative", width: "230px" }}>
       
            <button
              onClick={() => setIsDateModalOpen(true)}
              style={{
                width: "100%",
                height: "56px",
                padding: "0 40px 0 12px",   // space for right icon
                borderRadius: "4px",
                border: "1px solid #ccc",   // outlined style
                backgroundColor: "#FFFFFF",
                fontFamily: "Montserrat, sans-serif",
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "143%",
                letterSpacing: "0.15px",
                color:'#9E9E9E',
                textAlign: "left",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                opacity: 1,
              }}
            >
     Date Range
    <img
      src={calender}
      alt="dropdown arrow"
      style={{
        width: "16px",
        height: "16px",
      }}
    />
  </button>
</div>


          {isDateModalOpen && (
            <div
              className="modal-overlay"
              onClick={() => setIsDateModalOpen(false)}
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0,0,0,0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
              }}
            >
              <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()}
                style={{
                  background: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  minWidth: "320px",
                }}
              >
                <h3>Select Date Range</h3>
                <DateRangePicker
                  ranges={[
                    {
                      startDate: tempStartDate,
                      endDate: tempEndDate,
                      key: "selection",
                    },
                  ]}
                  onChange={(ranges) => {
                    setTempStartDate(ranges.selection.startDate);
                    setTempEndDate(ranges.selection.endDate);
                  }}
                  moveRangeOnFirstSelection={false}
                />

                <div style={{ marginTop: "10px", textAlign: "right" }}>
                  <button
                    onClick={handleApplyDateRange}
                    style={{
                      padding: "6px 12px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      cursor: "pointer",
                    }}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          )}
          <div style={{ position: "relative", width: "230px" }}>
            <select
              value={selectedOrg}
              onChange={(e) => setSelectedOrg(e.target.value)}
              style={{
                width: "100%",
                height: "56px",
                padding: "0 40px 0 12px",
                border: "1px solid #9E9E9E",
                borderRadius: "4px",
                fontFamily: "Montserrat, sans-serif",
                fontWeight: 400,
                color:'#9E9E9E',
                fontSize: "14px",
                lineHeight: "143%",
                letterSpacing: "0.15px",
                appearance: "none",
                backgroundColor: "#fff",  
                cursor: "pointer"
              }}
            >
              <option value="">Organization</option>
              {orgNames.map((orgName) => (
                <option key={orgName} value={orgName}>
                  {orgName}
                </option>
              ))}
            </select>

            {/* Bottom arrow PNG */}
            <img
              src={arrowImg}
              alt="dropdown arrow"
              style={{
                position: "absolute",
                right: "12px",
                top: "50%",
                transform: "translateY(-50%)",
                pointerEvents: "none",
                width: "16px", // adjust size if needed
                height: "16px"
              }}
            />
          </div>


          {/* <select value={selectedProgram} onChange={(e) => setSelectedProgram(e.target.value)}>
            <option value="">All Programs</option>
            {progNames.map((progName) => (
              <option key={progName} value={progName}>
                {progName}
              </option>
            ))}
          </select> */}
       <div style={{ position: "relative", width: "230px" }}>
          <select value={selectedCaseId} onChange={(e) => setSelectedCaseId(e.target.value)}
            style={{
              width: "100%",
              height: "56px",
              padding: "0 40px 0 12px",
              border: "1px solid #9E9E9E",
              borderRadius: "4px",
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 400,
              fontSize: "14px",
              color:'#9E9E9E',
              lineHeight: "143%",
              letterSpacing: "0.15px",
              appearance: "none",
              backgroundColor: "#fff",
              cursor: "pointer"
            }}
          >
            <option value="">Case ID</option>
            {caseIds.map((caseId) => (
              <option key={caseId} value={caseId}>
                {caseId}
              </option>
            ))}
          </select> <img
              src={arrowImg}
              alt="dropdown arrow"
              style={{
                position: "absolute",
                right: "12px",
                top: "50%",
                transform: "translateY(-50%)",
                pointerEvents: "none",
                width: "16px", // adjust size if needed
                height: "16px"
              }}
            />
          </div>
           <div style={{ position: "relative", width: "230px" }}>
          <select value={selectedUserName} onChange={(e) => setSelectedUserName(e.target.value)}
              style={{
              width: "100%",
              color:'#9E9E9E',
              height: "56px",
              padding: "0 40px 0 12px",
              border: "1px solid #9E9E9E",
              borderRadius: "4px",
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "143%",
              letterSpacing: "0.15px",
              appearance: "none",
              backgroundColor: "#fff",
              cursor: "pointer"
            }}>
            <option value="">Username</option>
            {userName.map((user) => (
              <option key={user} value={user}>
                {user}
              </option>
            ))}
          </select><img
              src={arrowImg}
              alt="dropdown arrow"
              style={{
                position: "absolute",
                right: "12px",
                top: "50%",
                transform: "translateY(-50%)",
                pointerEvents: "none",
                width: "16px", // adjust size if needed
                height: "16px"
              }}
            /></div>
        </div>

        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                {/* <th onClick={toggleDateSort} style={{ cursor: "pointer" }}>
                  Date {dateSortOrder === "asc" ? "↑" : dateSortOrder === "desc" ? "↓" : "↕"}
                </th> */}
                <th>Start Date</th>
                <th>End Date</th>
                <th>Case ID</th>
                <th>Name</th>
                <th>Inspection</th>
                <th>Status</th>
                <th>Report</th>
                {/* <th>Program Name</th> */}
                {/* <th onClick={toggleOrgSort} style={{ cursor: "pointer" }}>
                  Insurance Company {orgSortOrder === "asc" ? "↑" : orgSortOrder === "desc" ? "↓" : "↕"}
                </th> */}
                <th>Vet Name</th>
                <th>Remark</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="9" className="no-results">
                    Loading...
                  </td>
                </tr>
              ) : filteredData.length > 0 ? (
                filteredData.map((row, index) => (
                  <tr key={index}>
                    
                    <td>{moment(startDate).format("YYYY-MM-DD")}</td>
                   <td>{moment(endDate).format("YYYY-MM-DD")}</td>

                    <td>{row.caseId}</td>
                    <td>{row.name}</td>
                    <td>{row.inspectionlink}</td>
                    <td>
                      <span className="status" style={getStatusClass(row.status)}>
                        {row.status || "Pending"}
                      </span>
                    </td>
                    <td>
                      {row.status === "processed" && pdfLinks[row.audit] ? (
                        <a
                          href={pdfLinks[row.audit]}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "#ff0083",
                            textDecoration: "none",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            display: "inline-block",
                            maxWidth: "150px",
                            verticalAlign: "middle",
                            padding: "2px",
                          }}
                          title={pdfLinks[row.audit]}
                        >
                          View
                        </a>
                      ) : (
                        "Not generated"
                      )}
                    </td>
                    <td>{row.vetName}</td>
                    {/* <td>{row.programName || "-"}</td>
                    <td>{row.orgName}</td>
                    <td>{row.userName || "-"}</td> */}
                    <td>
                      {row.remark && row.status === "processed" ? (
                        <div
                          className="tooltip-container clickable"
                          title={row.remark}
                          onClick={() => {
                            setSelectedRemark(row.remark);
                            setShowRemarkPopup(true);
                          }}
                        >
                          <img
                            src={remarkIcon}
                            alt="Remark"
                            className="remark-icon"
                            style={{
                              filter: "brightness(90) saturate(0%) invert(21%) sepia(92%) saturate(7030%) hue-rotate(308deg) brightness(100%) contrast(124%)",
                            }}
                          />
                        </div>
                      ) : (
                        <div className="tooltip-container">
                          <img
                            src={remarkIcon}
                            alt="No Remark"
                            className="remark-icon"
                            style={{
                              filter: "grayscale(100%) brightness(80%)",
                            }}
                          />
                        </div>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="no-results">
                    No results found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showRemarkPopup && (
        <div className="remark-popup-overlay" onClick={() => setShowRemarkPopup(false)}>
          <div className="remark-popup" onClick={(e) => e.stopPropagation()}>
            <h3>Remark</h3>
            <p>{selectedRemark}</p>
            <button onClick={() => setShowRemarkPopup(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default InspectSuper;

